import React, { useMemo } from "react";
import { Select, Form } from "antd";
import { Controller } from "react-hook-form";
import "@ant-design/compatible/assets/index.css";

const { Option } = Select;

const SelectForm = ({
  formItem,
  selectChange = () => {},
  control,
  errors = [],
  loading = false,
  dataSource = [],
  disable = false,
  required = false,
  layOutSpan = 4,
  valueKey,
}) => {
  const optionsForSelect = useMemo(() => {
    return dataSource?.map((data) => (
      <Option key={data._id} value={data._id}>
        {data[`${valueKey}`]}
      </Option>
    ));
  }, [dataSource]);

  return (
    <Form.Item
      label={formItem.label}
      labelCol={{ span: layOutSpan }}
      name={formItem.name}
      validateStatus={errors && errors[formItem.name] ? "error" : ""}
      help={errors[formItem.name]?.message}
      required={required}
    >
      <Controller
        control={control}
        name={formItem.name}
        render={({ field: { onChange, value } }) => (
          <Select
            showSearch
            allowClear
            placeholder={formItem.placeholder}
            onChange={(values) => {
              onChange(values);
              selectChange(values);
            }}
            value={value}
            optionFilterProp="children"
            loading={loading}
            disabled={disable}
          >
            {optionsForSelect}
          </Select>
        )}
      />
    </Form.Item>
  );
};

export default SelectForm;
